import { ChangeEvent } from 'react';
import { TextInput } from '../../Calculators/calculator-revamp/components/form-components/InputBox';
import { AtcIncomeDetailsData } from '../Atc-calculator-constants';
import { CALCULATOR_TAB_PROPS } from '../types';
import AtcBusinessIncome from './atc-business-income';
import AtcCapitalGains from './atc-capital-gains';
import { handleTrack } from '../../../utils/tracker';
import { removeCommas } from '../../Utils/CommonUtils';

const AtcIncomeDetails = ({
  hasError,
  setGlobalError,
  setInputData,
  inputTabData,
}: CALCULATOR_TAB_PROPS) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const key = e.target.id;
    const value = removeCommas(e.target.value);
    handleTrack({ label: `ATC_Income_details_${key}` });
    setInputData?.((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div>
      <div className="grid grid-rows-2 grid-cols-2 gap-x-12 gap-y-6 sm:block font-medium">
        {AtcIncomeDetailsData?.map((props, index) => {
          return (
            <TextInput
              key={index}
              {...props}
              value={`${inputTabData?.[props.id]}` || ''}
              hasError={hasError}
              setGlobalError={setGlobalError}
              onTextChangeFn={handleChange}
            />
          );
        })}
      </div>
      <AtcCapitalGains
        hasError={hasError}
        setGlobalError={setGlobalError}
        setInputData={setInputData}
        inputTabData={inputTabData}
      />
      <AtcBusinessIncome
        hasError={hasError}
        setGlobalError={setGlobalError}
        setInputData={setInputData}
        inputTabData={inputTabData}
      />
    </div>
  );
};

export default AtcIncomeDetails;
